import { Injectable } from '@angular/core';

import { TranslocoService } from '@ngneat/transloco';

@Injectable({
  providedIn: 'root',
})
export class UpdateService {
  translate = (key: string | string[], params?: Record<string, string>, lang?: string) =>
    this.translocoService.translate(key, params, lang);

  constructor(private translocoService: TranslocoService) {}

  init() {
    // disabled until service workers on the same domain is supported
    // if (!environment.production || !this.swUpdate) {
    //   return;
    // }
    // this.applicationRef.isStable.pipe(first((isStable) => isStable === true)).subscribe(() => {
    //   // check for updates every six hours
    //   interval(6 * 60 * 60 * 1000)
    //     .pipe()
    //     .subscribe(() => {
    //       this.checkForUpdates();
    //     });
    // });
    // this.swUpdate.versionUpdates.subscribe((event) => {
    //   switch (event.type) {
    //     case 'VERSION_DETECTED':
    //       this.notificationService.info({
    //         message: this.translate('core.services.update.update_downloading'),
    //       });
    //       break;
    //     case 'VERSION_READY':
    //       this.notificationService.clear();
    //       this.notificationService.info({
    //         message: this.translate('core.services.update.update_ready'),
    //         closable: false,
    //         progressBar: false,
    //         sticky: true,
    //         actionLabel: this.translate('core.services.update.action.update_now'),
    //         action: () => {
    //           window.location.reload();
    //         },
    //       });
    //       break;
    //     case 'VERSION_INSTALLATION_FAILED':
    //       this.notificationService.error({
    //         message: this.translate('core.services.update.update_install_failed', { hash: event.version.hash, error: event.error }),
    //         sticky: true,
    //         progressBar: false,
    //       });
    //       break;
    //   }
    // });
  }

  checkForUpdates() {
    // disabled until service workers on the same domain is supported
    // if (!environment.production || !this.swUpdate) {
    //   return;
    // }
    // this.swUpdate
    //   .checkForUpdate()
    //   .then((updateFound) => {
    //     if (!updateFound) {
    //       this.notificationService.info({
    //         message: this.translate('core.services.update.no_updates'),
    //       });
    //     }
    //   })
    //   .catch((error) => {
    //     this.notificationService.error({
    //       message: this.translate('core.services.update.update_check_failed', { error }),
    //     });
    //   });
  }
}
